module.exports = __webpack_public_path__ + "img/1-sm.ffa2ddc6.jpg";